<template>
  <div id="mol-member-edit">
    <v-card class="edit-card" elevation="0" rounded="lg">
      <!-- Header Section -->
      <v-card class="header-card mb-8 overflow-hidden">
        <v-row align="center" class="fill-height pa-6">
          <v-col sm="7" xs="12" class="header-content d-flex align-center">
            <div class="header-icon-box">
              <v-icon size="48" color="white">mdi-file-document-edit</v-icon>
            </div>
            <div class="header-text-content">
              <h1 class="header-title">{{ PageTitle }}</h1>
              <p class="header-subtitle">
                Update prospective member information and details
              </p>
            </div>
          </v-col>
          <v-col sm="5" xs="12" class="d-flex justify-end align-center gap-2">
            <v-btn @click="closePrompt" icon rounded class="action-btn" x-large>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <!-- Form Section -->
      <v-container fluid class="px-6 px-md-8">
        <!-- Instructions Card -->
        <v-card class="instructions-card mb-8" elevation="0">
          <div class="instruction-heading">
            <v-icon class="mr-3">mdi-information-outline</v-icon>
            Important Requirements
          </div>
          <div class="instruction-content">
            <div class="requirement-box mb-4">
              <v-icon class="mr-3">mdi-check-circle</v-icon>
              <span
                >The member should be within <strong>18 to 40 years</strong> of
                age</span
              >
            </div>
            <div class="requirement-box">
              <v-icon class="mr-3">mdi-check-circle</v-icon>
              <span
                >Photo must be <strong>JPG format</strong> and
                <strong>less than 1 MB</strong></span
              >
            </div>
          </div>
        </v-card>

        <!-- Form Card -->
        <v-card class="form-card mb-8" elevation="0">
          <v-form ref="form1" v-model="valid1" lazy-validation>
            <!-- Personal Information Section -->
            <div class="form-section">
              <h3 class="section-title mb-6">
                <v-icon class="mr-2">mdi-account</v-icon>
                Personal Information
              </h3>

              <v-row>
                <v-col cols="12" sm="6" md="4" v-if="false">
                  <div class="form-field">
                    <label class="field-label required-field"
                      >Date of Birth</label
                    >
                    <v-menu
                      v-model="menu1"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="DateOfBirth"
                          readonly
                          v-on="on"
                          dense
                          outlined
                          prepend-icon="mdi-calendar-clock"
                          class="field-input"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="DateOfBirth"
                        @input="menu1 = false"
                      ></v-date-picker>
                    </v-menu>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <div class="form-field">
                    <label class="field-label required-field">Full Name</label>
                    <v-text-field
                      :rules="Name"
                      v-model="MemberName"
                      type="text"
                      dense
                      outlined
                      prepend-icon="mdi-account-circle"
                      class="field-input"
                    ></v-text-field>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <div class="form-field">
                    <label class="field-label required-field"
                      >WhatsApp Number</label
                    >
                    <v-text-field
                      :counter="10"
                      v-mask="'##########'"
                      :rules="PhoneNumberRules"
                      v-model="PhoneNumber"
                      type="number"
                      dense
                      outlined
                      prepend-icon="mdi-phone"
                      class="field-input"
                    ></v-text-field>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <div class="form-field">
                    <label class="field-label required-field"
                      >Email Address</label
                    >
                    <v-text-field
                      v-model="EmailID"
                      :rules="EmailIDRules"
                      type="email"
                      dense
                      outlined
                      prepend-icon="mdi-email"
                      class="field-input"
                    ></v-text-field>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4" v-if="false">
                  <div class="form-field">
                    <label class="field-label required-field">City</label>
                    <v-text-field
                      :rules="CityRules"
                      v-model="City"
                      type="text"
                      dense
                      outlined
                      prepend-icon="mdi-map-marker"
                      class="field-input"
                    ></v-text-field>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4" v-if="false">
                  <div class="form-field">
                    <label class="field-label">Address (Optional)</label>
                    <v-textarea
                      v-model="Address"
                      dense
                      outlined
                      prepend-icon="mdi-home"
                      rows="2"
                      class="field-input"
                    ></v-textarea>
                  </div>
                </v-col>
              </v-row>
            </div>

            <!-- Photo Section -->
            <div class="form-section mt-8" v-if="false">
              <h3 class="section-title mb-6">
                <v-icon class="mr-2">mdi-camera</v-icon>
                Member Photo
              </h3>

              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <div class="form-field">
                    <label class="field-label">Current Photo</label>
                    <div class="photo-display">
                      <img
                        :src="PhotoPath"
                        alt="Member Photo"
                        class="member-photo"
                      />
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <div class="form-field">
                    <label class="field-label">Update Photo (Optional)</label>
                    <v-file-input
                      prepend-icon="mdi-camera-plus"
                      v-model="MemberImage"
                      accept="image/jpeg,image/png,image/jpg"
                      :rules="PhotoRules"
                      dense
                      outlined
                      class="field-input"
                    ></v-file-input>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card>

        <!-- Action Buttons -->
        <div class="action-section mb-6">
          <v-row justify="end" class="gap-3">
            <v-col cols="auto">
              <v-btn
                @click.prevent="closePrompt"
                rounded
                outlined
                class="action-cancel-btn"
                min-width="150"
              >
                <v-icon left>mdi-close</v-icon>
                Cancel
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn
                :disabled="!valid1"
                @click.prevent="confirmAlert"
                :loading="SubmitFlag"
                rounded
                class="action-save-btn"
                min-width="150"
                color="white"
              >
                <v-icon left>mdi-check-circle</v-icon>
                Update Member
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    addRecordPrompt: {
      type: Boolean,
      required: true,
    },
    EditRecordPrompt: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
    },
    pageDescription: {
      type: String,
    },
    recordData: {
      type: Array,
      required: true,
    },
    LomCode: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      menu1: false,
      CreatedDate: "",
      Name: [(v) => !!v || "Name is required"],
      PhoneNumberRules: [(v) => !!v || "Whatsapp Number is required"],
      EmailIDRules: [(v) => !!v || "Email is required"],
      ResultFlag: false,
      DateOfBirth: "",
      rows: [],
      MemberId: "",
      MemberName: "",
      City: "",
      CityRules: [(v) => !!v || "City is required"],
      EmailID: "",
      PhoneNumber: "",
      PageInfo: {},
      Address: "",
      MemberImage: "",
      PageTitle: "",
      PageDescription: "",
      PhotoPath: "",
      PhotoRules: [
        (v) => !v || v.size <= 1048576 || "Photo must be less than 1 MB",
      ],
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = CurrentJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        var ZoneCode = this.$session.get("ZoneId");
        ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
        console.log("ZoneCode=" + ZoneCode);
        this.ZoneCode = ZoneCode;
      }
    },
  },
  created() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "mol_non_member",
        Action: "edit",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
      // var MemberId = [];
      // MemberId = [this.recordData.MolMemberId];
      // this.MemberId = MemberId;
      this.MemberId = this.recordData.MolMemberId;
      this.MemberName = this.recordData.MemberName;
      this.PhoneNumber = this.recordData.MobileNumber;
      this.DateOfBirth = this.recordData.DateOfBirth;
      this.EmailID = this.recordData.Email;
      this.Address = this.recordData.Address;
      this.City = this.recordData.City;
      this.PhotoPath = this.recordData.PhotoPath;

      // this.getMemberIdOptions();
    },
    resetForm() {
      console.log("resetForm called");
      this.$refs.form1.reset();
    },
    closePrompt() {
      console.log("closePrompt called");
      console.log(this.ResultFlag);
      this.$emit("hideEditRecordPrompt", this.ResultFlag);
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields");
      }
    },
    submitForm() {
      console.log("submitForm is called");

      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);

      //   validate1 = false;

      if (validate1) {
        this.SubmitFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/mission-onelakh/mol-member-update";
        var upload = new FormData();
        upload.append("UserInterface", 1);
        upload.append("MolMember", this.MemberId);
        upload.append("MemberName", this.MemberName);
        upload.append("MobileNumber", this.PhoneNumber);
        upload.append("EmailID", this.EmailID);
        // upload.append("DateOfBirth", this.DateOfBirth);
        // upload.append("Address", this.Address);
        // upload.append("MemberPhoto", this.MemberImage);
        // upload.append("City", this.City);

        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.SubmitFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.resetForm();
              thisIns.closePrompt();
              thisIns.sweetAlert("success", output, true);
              this.toast("success", output);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SubmitFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields";
        }
        thisIns.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>

<style lang="scss">
// Color Palette - JCI Brand Colors
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$text-off-black: #0a0f29;
$text-white: #ffffff;
$success-green: #4caf50;
$error-red: #f44336;

// Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

#mol-member-edit {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 30px 15px;

  .edit-card {
    border-radius: 20px !important;
    background: #ffffff !important;
    animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .header-card {
    background: linear-gradient(
      135deg,
      $navy 0%,
      $aqua 50%,
      $navy 100%
    ) !important;
    border-radius: 20px !important;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5),
      0 0 40px rgba(0, 151, 215, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        45deg,
        transparent 30%,
        rgba(255, 255, 255, 0.1) 50%,
        transparent 70%
      );
      animation: shimmer 3s infinite;
    }

    .header-content {
      position: relative;
      z-index: 2;
    }
  }

  .header-icon-box {
    background: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.25) 0%,
      rgba(255, 255, 255, 0.15) 100%
    );
    backdrop-filter: blur(15px);
    border-radius: 16px;
    padding: 16px;
    width: fit-content;
    flex-shrink: 0;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2),
      inset 0 1px 0 rgba(255, 255, 255, 0.4);
    animation: float 4s ease-in-out infinite;
    border: 2px solid rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
    margin-right: 20px;

    &:hover {
      transform: scale(1.1);
      box-shadow: 0 16px 48px rgba(0, 0, 0, 0.3),
        inset 0 1px 0 rgba(255, 255, 255, 0.5);
    }
  }

  .header-text-content {
    flex: 1;
    min-width: 0;
  }

  .header-title {
    font-size: 32px;
    font-weight: 900;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 151, 215, 0.3);
    animation: slideInLeft 0.8s ease-out;
    letter-spacing: 0.8px;
    color: $text-white;
    margin: 0;
    padding: 0;
    line-height: 1.2;
  }

  .header-subtitle {
    font-size: 15px;
    opacity: 0.95;
    animation: slideInLeft 1s ease-out 0.1s backwards;
    letter-spacing: 0.3px;
    color: rgba($text-white, 0.9);
    font-weight: 500;
    margin: 6px 0 0 0;
    line-height: 1.4;
  }

  .action-btn {
    background: rgba(255, 255, 255, 0.15) !important;
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    color: white !important;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

    &:hover {
      transform: translateY(-6px);
      background: rgba(255, 255, 255, 0.25) !important;
      border-color: rgba(255, 255, 255, 0.5) !important;
      box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3) !important;
    }
  }

  .instructions-card {
    border-radius: 16px !important;
    background: linear-gradient(135deg, #fff5e6 0%, #fffaf0 100%) !important;
    box-shadow: 0 12px 32px rgba(237, 190, 56, 0.15) !important;
    border: 2px solid rgba(237, 190, 56, 0.25) !important;
    padding: 24px !important;
    animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s backwards;

    .instruction-heading {
      font-size: 16px;
      font-weight: 800;
      color: $navy;
      display: flex;
      align-items: center;
      margin: 0 0 16px 0;
      text-transform: uppercase;
      letter-spacing: 0.6px;

      .v-icon {
        transition: all 0.3s ease;
      }
      &:hover .v-icon {
        transform: rotate(20deg) scale(1.15);
      }
    }

    .instruction-content {
      .requirement-box {
        display: flex;
        gap: 16px;
        background: linear-gradient(
          135deg,
          rgba(76, 175, 80, 0.12),
          rgba(76, 175, 80, 0.08)
        );
        border-left: 5px solid $success-green;
        padding: 16px 14px;
        border-radius: 12px;
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(
            135deg,
            rgba(76, 175, 80, 0.15),
            rgba(76, 175, 80, 0.1)
          );
          box-shadow: 0 6px 16px rgba(76, 175, 80, 0.15);
          transform: translateY(-2px);
        }

        .v-icon {
          flex-shrink: 0;
          transition: all 0.3s ease;
        }
        &:hover .v-icon {
          transform: scale(1.2);
        }

        span {
          color: $text-off-black;
          font-weight: 600;
          font-size: 14px;
          line-height: 1.6;
        }
      }
    }
  }

  .form-card {
    border-radius: 16px !important;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
    box-shadow: 0 16px 48px rgba(58, 103, 177, 0.12) !important;
    border: 2px solid rgba(0, 151, 215, 0.1) !important;
    padding: 24px !important;
    animation: slideInUp 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s backwards;

    .form-section {
      .section-title {
        font-size: 18px;
        font-weight: 800;
        color: $navy;
        display: flex;
        align-items: center;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        padding-bottom: 12px;
        border-bottom: 3px solid $aqua;

        .v-icon {
          transition: all 0.3s ease;
        }
        &:hover .v-icon {
          transform: rotate(-10deg) scale(1.15);
        }
      }

      .form-field {
        margin-bottom: 8px;

        .field-label {
          font-size: 13px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: $navy;
          display: block;
          margin-bottom: 8px;

          &.required-field::after {
            content: "*";
            color: $error-red;
            margin-left: 4px;
          }
        }

        .field-input {
          transition: all 0.3s ease;

          &::v-deep {
            .v-input__prepend-outer {
              margin-right: 8px !important;
              .v-icon {
                color: $aqua;
              }
            }

            .v-input__control {
              .v-input__slot {
                input,
                textarea {
                  color: $text-off-black;
                  font-weight: 600;

                  &::placeholder {
                    color: #aaa !important;
                    font-weight: 500;
                  }
                }
              }
            }

            fieldset {
              border-color: rgba(0, 151, 215, 0.2) !important;
            }

            &.v-input--is-focused {
              fieldset {
                border-color: $aqua !important;
              }
              .v-icon {
                color: $navy;
              }
            }
          }
        }

        .photo-display {
          background: linear-gradient(135deg, #f5f7fa 0%, #eef2f7 100%);
          border: 2px dashed rgba(0, 151, 215, 0.3);
          border-radius: 12px;
          padding: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 200px;
          transition: all 0.3s ease;

          &:hover {
            border-color: rgba(0, 151, 215, 0.6);
            background: linear-gradient(135deg, #f8fafc 0%, #f0f5fa 100%);
          }

          .member-photo {
            max-width: 100%;
            max-height: 180px;
            border-radius: 8px;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
            transition: all 0.3s ease;

            &:hover {
              transform: scale(1.05);
              box-shadow: 0 12px 36px rgba(0, 151, 215, 0.3);
            }
          }
        }
      }
    }
  }

  .action-section {
    padding: 20px 0;
    border-top: 2px solid #f0f0f0;
    margin-top: 20px;

    .gap-3 {
      gap: 16px;
    }

    .action-cancel-btn {
      font-weight: 700 !important;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      color: #666 !important;
      border-color: #ddd !important;
      transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

      &:hover {
        border-color: $aqua !important;
        color: $aqua !important;
        transform: translateY(-4px);
        box-shadow: 0 8px 20px rgba(0, 151, 215, 0.2) !important;
      }

      .v-icon {
        transition: all 0.3s ease;
      }
      &:hover .v-icon {
        transform: scale(1.15);
      }
    }

    .action-save-btn {
      background: linear-gradient(135deg, $navy 0%, $aqua 100%) !important;
      font-weight: 700 !important;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      box-shadow: 0 12px 32px rgba(0, 151, 215, 0.3) !important;
      transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);

      &:hover:not(:disabled) {
        transform: translateY(-6px);
        box-shadow: 0 16px 48px rgba(0, 151, 215, 0.4) !important;
      }

      &:disabled {
        background: linear-gradient(135deg, #ccc 0%, #aaa 100%) !important;
        box-shadow: none !important;
      }

      .v-icon {
        transition: all 0.3s ease;
      }
      &:hover:not(:disabled) .v-icon {
        transform: scale(1.2);
      }
    }
  }

  @media (max-width: 960px) {
    padding: 20px 12px;

    .header-card {
      border-radius: 16px;
    }
    .header-title {
      font-size: 26px;
    }
    .header-subtitle {
      font-size: 14px;
    }
    .section-title {
      font-size: 16px;
    }
    .form-card,
    .instructions-card {
      border-radius: 14px;
    }

    .action-section {
      .v-row > * {
        margin: 8px 0;
      }
    }
  }

  @media (max-width: 600px) {
    padding: 16px 10px;

    .header-card {
      border-radius: 14px;
    }
    .header-title {
      font-size: 20px;
    }
    .header-subtitle {
      font-size: 12px;
    }
    .section-title {
      font-size: 14px;
    }
    .form-card,
    .instructions-card {
      border-radius: 12px;
      padding: 16px !important;
    }

    .action-section {
      flex-direction: column;

      .action-cancel-btn,
      .action-save-btn {
        width: 100% !important;
        min-width: unset !important;
      }

      .v-row > * {
        margin: 6px 0;
      }
    }

    .photo-display {
      min-height: 150px;

      .member-photo {
        max-height: 120px;
      }
    }
  }
}
</style>